export type FileType = "image" | "html" | "code" | "pdf" | "csv" | "json" | "unsupported";

export const getFileType = (fileName: string): FileType => {
  const imageRegex = /\.(png|jpg|jpeg|gif)$/i;
  const htmlRegex = /\.html$/i;
  const codeRegex = /\.(txt|py|js|jsx|ts|tsx|css|scss|c|cpp|cs|java|md|xml|yml|yaml|sh|sql)$/i;
  const pdfRegex = /\.pdf$/i;
  const csvRegex = /\.csv$/i;
  const jsonRegex = /\.json$/i;

  if (imageRegex.test(fileName)) return "image";
  if (htmlRegex.test(fileName)) return "html";
  if (codeRegex.test(fileName)) return "code";
  if (pdfRegex.test(fileName)) return "pdf";
  if (csvRegex.test(fileName)) return "csv";
  if (jsonRegex.test(fileName)) return "json";
  return "unsupported";
};

export const getFileTypeRegex = (fileType: FileType) => {
  switch (fileType) {
    case "image": return /\.(png|jpg|jpeg|gif)$/i;
    case "html": return /\.html$/i;
    case "code": return /\.(txt|py|js|jsx|ts|tsx|css|scss|c|cpp|cs|java|md|xml|yml|yaml|sh|sql)$/i;
    case "pdf": return /\.pdf$/i;
    case "csv": return /\.csv$/i;
    case "json": return /\.json$/i;
    default: return null;
  }
};

// JSON Tree themes to match syntax highlighting themes
export const getJsonTheme = (selectedTheme: string) => {
  const isDark = ["vscDarkPlus", "nightOwl", "atomDark", "duotoneDark"].includes(selectedTheme);

  if (isDark) {
    return {
      scheme: "monokai",
      author: "wimer hazenberg (http://www.monokai.nl)",
      base00: "#272822",
      base01: "#383830",
      base02: "#49483e",
      base03: "#75715e",
      base04: "#a59f85",
      base05: "#f8f8f2",
      base06: "#f5f4f1",
      base07: "#f9f8f5",
      base08: "#f92672",
      base09: "#fd971f",
      base0A: "#f4bf75",
      base0B: "#a6e22e",
      base0C: "#a1efe4",
      base0D: "#66d9ef",
      base0E: "#ae81ff",
      base0F: "#cc6633",
    };
  } else {
    return {
      scheme: "default",
      author: "chris kempson (http://chriskempson.com)",
      base00: "#f8f8f8",
      base01: "#e8e8e8",
      base02: "#d8d8d8",
      base03: "#b8b8b8",
      base04: "#585858",
      base05: "#383838",
      base06: "#282828",
      base07: "#181818",
      base08: "#ab4642",
      base09: "#dc9656",
      base0A: "#f7ca88",
      base0B: "#a1b56c",
      base0C: "#86c1b9",
      base0D: "#7cafc2",
      base0E: "#ba8baf",
      base0F: "#a16946",
    };
  }
};